import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { prepareFilters } from '../../components/Filters/request';
import { fetch, handleErrors } from '../../api';
import api from '../../api/endpoints';

function* generateAnalyticsUsersReport({ payload: { filters, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.analytics.links_report, data: { ...prepareFilters(filters), page: curr_page } });

    yield put(actions.generateAnalyticsUsersReportDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.generateAnalyticsUsersReportFailed,
      endpoint: api.analytics.users_report.url
    });
  }
}

export const generateAnalyticsUsersReportSaga = takeEvery(types.GENERATE_ANALYTICS_USERS_REPORT_REQUEST, generateAnalyticsUsersReport);


